import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'disability-types',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'disability-types-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.disability-types-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "disability-types-index" */ '@/modules/configurations/catalogs/disability-types/views/Index.vue')
        },
        {
            path: 'create',
            name: 'disability-types-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'disability-types-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.disability-types-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.disability-types-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "disability-types-create" */ '@/modules/configurations/catalogs/disability-types/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'disability-types-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'disability-types-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.disability-types-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.disability-types-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "disability-types-edit" */ '@/modules/configurations/catalogs/disability-types/views/Edit.vue')
        }
    ]
}